<div class="employee-details-section">
  <h2 mat-dialog-title>Employee Details</h2>

  <!-- Employee Details Table -->
  <table class="employee-details-table">
    <tbody>
    <tr>
      <th>Employee ID</th>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <th>First Name</th>
      <td>{{ details.firstname }}</td>
    </tr>
    <tr *ngIf="details.middlename">
      <th>Middle Name</th>
      <td>{{ details.middlename }}</td>
    </tr>
    <tr>
      <th>Last Name</th>
      <td>{{ details.lastname }}</td>
    </tr>
    <tr>
      <th>Email</th>
      <td>{{ details.email }}</td>
    </tr>
    </tbody>
  </table>
  <div *ngIf="bankingInfo$ | async as bankingInfo">
    <h2 mat-dialog-title>Employee Banking Information</h2>
    <mat-tab-group>
      <mat-tab *ngFor="let countryInfo of bankingInfo" [label]="countryInfo.country">
        <table class="employee-details-table" *ngIf="BANKING_INFO_LABEL_MAPPING[countryInfo.country] as mapping">
          <tbody>
          <tr *ngIf="countryInfo.employmentStatus">
            <th>Employment Status:</th>
            <td>{{ countryInfo.employmentStatus }} {{countryInfo.terminationDate ? '(' + (countryInfo.terminationDate | date: 'MM/dd/yyyy') + ')' : '' }}</td>
          </tr>
          <tr>
            <th>Account Name</th>
            <td>{{ countryInfo.accountName }}</td>
          </tr>
          <tr>
            <th>Account Type</th>
            <td>{{ countryInfo.accountType }}</td>
          </tr>
          <tr>
            <th>Account Number</th>
            <td>{{ countryInfo.accountNumber }}</td>
          </tr>
          <tr *ngIf="countryInfo.address">
            <th>Address</th>
            <td>{{ countryInfo.address }}</td>
          </tr>
          <tr>
            <th>Country</th>
            <td>{{ countryInfo.country }}</td>
          </tr>
          <tr *ngIf="mapping['attribute1']">
            <th>{{mapping['attribute1']}}</th>
            <td>{{ countryInfo.attribute1 }}</td>
          </tr>
          <tr *ngIf="mapping['attribute2']">
            <th>{{mapping['attribute2']}}</th>
            <td>{{ countryInfo.attribute2 | uppercase }}</td>
          </tr>
          <tr *ngIf="mapping['attribute3']">
            <th>{{mapping['attribute3']}}</th>
            <td>{{ countryInfo.attribute3 }}</td>
          </tr>
          <tr *ngIf="mapping['attribute4']">
            <th>{{mapping['attribute4']}}</th>
            <td>{{ countryInfo.attribute4 }}</td>
          </tr>
          <tr *ngIf="mapping['attribute5']">
            <th>{{mapping['attribute5']}}</th>
            <td>{{ countryInfo.attribute5 }}</td>
          </tr>
          <tr>
            <th>Last Updated Date Time</th>
            <td>{{ countryInfo.updatedDatetime | date: 'MM/dd/yyyy  -  hh:mm a' }}</td>
          </tr>
          </tbody>
        </table>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Action Buttons -->
  <div mat-dialog-actions class="action-buttons">
    <button mat-button (click)="onCloseClick()">Close</button>
  </div>
</div>
